import {BehaviorSubject} from "rxjs";
import {hookFromSubject, promiseToSubject, ResponseSubjectState} from "./index";
import {BusinessSectorApi, BusinessSectorCreateEditDto, Configuration} from "../generated-api";
import {getCustomHeaders} from "./user";

const {REACT_APP_API_DOMAIN} = process.env;
const businessSectorApi = new BusinessSectorApi(new Configuration({
    basePath: REACT_APP_API_DOMAIN,
    getHeaders: getCustomHeaders
}));

export const businessSectorSubject = new BehaviorSubject(new ResponseSubjectState());
export const useBusinessSectors = hookFromSubject(businessSectorSubject);
export const getBusinessSectors = () =>
    promiseToSubject(businessSectorApi.apiBusinessSectorGet(), businessSectorSubject);

export const businessSectorCreateSubject = new BehaviorSubject(new ResponseSubjectState());
export const useBusinessSectorCreate = hookFromSubject(businessSectorCreateSubject);
export const createBusinessSector = (body?: BusinessSectorCreateEditDto) =>
    promiseToSubject(businessSectorApi.apiBusinessSectorPost(body), businessSectorCreateSubject);

export const businessSectorGuidSubject = new BehaviorSubject(new ResponseSubjectState());
export const useBusinessSectorGuid = hookFromSubject(businessSectorGuidSubject);
export const getBusinessSectorGuid = (guid: string, suppressErrors?: boolean) =>
    promiseToSubject(businessSectorApi.apiBusinessSectorGuidGet({guid}), businessSectorGuidSubject, {suppressErrors: suppressErrors});

export const updateBusinessSectorGuid = (guid: string, body?: BusinessSectorCreateEditDto) =>
    promiseToSubject(businessSectorApi.apiBusinessSectorGuidPut({guid}, body), businessSectorGuidSubject);
